import { useProgModeles } from 'containers/Programmations/ProgV2/New/useProgModeles';
import useClassrooms from 'containers/App/context/ClassroomsContext/useClassrooms';

export function useFilteredProgModeles(
  ...params: Parameters<typeof useProgModeles>
) {
  const classrooms = useClassrooms();
  const queryResult = useProgModeles(...params);
  const { data = [] } = queryResult;

  const allResultsAreForULIS = data.every(tt =>
    tt.categories.some(c => c.name === 'ULIS'),
  );
  const someClassroomIsULIS = classrooms.some(c => c.degree === 'ULIS');

  return {
    ...queryResult,
    data: !allResultsAreForULIS || someClassroomIsULIS ? data : [],
  };
}
